import {
  REQUEST_PROVIDER_SIGNUP,
  PROVIDER_SIGNUP_SUCCESS,
  PROVIDER_SIGNUP_FAILED,
  EDIT_TENANT,
  EDIT_TENANT_FAILED,
  EDIT_TENANT_STATUS,
  MAKE_FORM_EMPTY,
  TENANTS_REQUEST_SUCCESS,
  EDIT_TENANT_SUCCESS,
  GET_PROVIDER_PROFILE_SUCCESS,
} from "../action-type";

const providerData = {
  businessInformation: {
    legalName: "",
    displayName: "",
    displayImage: "",
    taxId: "",
    fileLink: "",
    cinNumber: "",
    cinNumberLink: "",
    gstId: "",
    gstIdLink: "",
    phoneNumber: "",
    website: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
  },
  officialRepresentative: {
    FName: "",
    LName: "",
    NFLink: "",
    SATitle: "",
  },
  financialInformation: {
    AHName: "",
    ANumber: "",
    BName: "",
    RCode: "",
    CCheque: "",
  },
};

const initialState = {
  error: null,
  isLoading: false,
  providerId: "",
  tenantId: "",
  providerData,
  tenants: [],
  tenant: {},
  totalTenants: null,
  showForm: false,
  providerProfile: {},
};

export const providerReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REQUEST_PROVIDER_SIGNUP:
      return { ...state, error: null, isLoading: true };

    case PROVIDER_SIGNUP_SUCCESS:
      return {
        ...state,
        isLoading: false,
        providerId: payload.providerId,
        tenantId: payload.tenantId,
      };
    case GET_PROVIDER_PROFILE_SUCCESS: return {
      ...state,
      providerProfile: payload
    }
    case "Change_Show_Form_State":
      return {
        ...state,
        showForm: payload,
      };

    case "MAKE_TENANT_NULL":
      return {
        ...state,
        tenant: {},
      };
    case "GET_TENANTS_REQUEST":
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    case PROVIDER_SIGNUP_FAILED:
      return {
        ...state,
        error: payload,
        isLoading: false,
        providerId: "",
        tenantId: "",
      };

    case EDIT_TENANT_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };

    case EDIT_TENANT_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };

    case TENANTS_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        tenants: payload.tenants,
        totalTenants: payload.totalTenants,
      };

    case EDIT_TENANT:
      return {
        ...state,
        isLoading: false,
        tenantId: payload._id,
        providerId: payload.userId,
        tenant: payload,
      };

    case MAKE_FORM_EMPTY:
      return { ...state, tenantId: "", providerId: "", providerProfile: {}, tenant: {}, error: null, providerData };

    case EDIT_TENANT_STATUS:
      const updatedTenants = state.tenants.map((elm) =>
        elm._id === payload.tenantId ? { ...elm, status: payload.status } : elm
      );
      return {
        ...state,
        tenants: updatedTenants,
      };

    default:
      return state;
  }
};
